import { useEffect, useState } from "react";

/**
 * A `Date.now()` that ticks every `intervalMs` so relative-age readouts
 * ("3 min ago", freshness pips, the "ends X ago" badge) stay live.
 *
 * Also re-pins immediately when the tab becomes visible again: background
 * tabs are throttled by the browser (interval timers are coalesced to as
 * little as once per minute when hidden), so on an always-on wall-display
 * iframe a just-revealed page would otherwise show ages frozen at the
 * moment it was hidden until the next slow tick. Re-pinning on
 * `visibilitychange` makes ages correct the instant the operator looks
 * (Never-lie), with no extra renders while the tab stays focused.
 */
export function useNow(intervalMs = 1000) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), intervalMs);
    const onVisible = () => {
      if (document.visibilityState === "visible") setNow(Date.now());
    };
    document.addEventListener("visibilitychange", onVisible);
    return () => {
      window.clearInterval(id);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, [intervalMs]);
  return now;
}
